import React from 'react';
import { Loader2, Maximize2, RefreshCw, BookOpen } from 'lucide-react';
import { Button } from '../ui/button';
import { useSlideImage } from './useFusedLesson';

export const FusedSlide = ({ page, title, onExpand, onReady, pageCount }) => {
  const { url, error, retry } = useSlideImage(page);
  return <figure className="fp-slide" data-testid="fused-slide-figure">
    <div className="fp-slide-art" data-testid="fused-slide-art">
      {url ? <img src={url} alt={`Diapositiva ${page}: ${title}`} data-testid="fused-slide-image" onLoad={() => onReady(true)} onError={() => onReady(false)} />
        : error ? <div className="fp-media-status" role="alert" data-testid="fused-slide-error"><p>{error}</p><Button variant="outline" onClick={retry} data-testid="fused-slide-retry"><RefreshCw size={16} />Reintentar</Button></div>
          : <div className="fp-media-status" role="status" data-testid="fused-slide-loading"><Loader2 className="animate-spin" size={24} /><span>Cargando diapositiva {page}…</span></div>}
    </div>
    <figcaption className="fp-slide-caption">
      <span data-testid="fused-slide-counter">Diapositiva {page}{pageCount ? ` de ${pageCount}` : ''} · PDF original</span>
      <Button variant="ghost" onClick={onExpand} disabled={!url} data-testid="fused-expand-slide"><Maximize2 size={16} />Ampliar</Button>
    </figcaption>
  </figure>;
};

export const FusedReadings = ({ readings, prefix = 'fused' }) => !readings.length ? null : <section className="fp-readings" data-testid={`${prefix}-readings`}>
  <div className="fp-reading-label"><BookOpen size={18} /><h2 data-testid={`${prefix}-readings-title`}>Ampliación del Masterclass</h2></div>
  <p className="fp-source-note" data-testid={`${prefix}-readings-source`}>Texto original del CSV · Revisión clínica pendiente</p>
  {readings.map(reading => <article key={reading.question_id} className="fp-reading" data-testid={`${prefix}-reading-${reading.question_id}`}>
    <h3 data-testid={`${prefix}-reading-title-${reading.question_id}`}>{reading.title}</h3>
    <p data-testid={`${prefix}-reading-text-${reading.question_id}`}>{reading.text}</p>
    <span className="fp-source-note" data-testid={`${prefix}-reading-reference-${reading.question_id}`}>Fuente: retroalimentación del reactivo {reading.question_id}</span>
  </article>)}
</section>;